import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useWindowSize from './useWindowSize';

export default function useRedirectMobile() {
  const router = useRouter();
  const { query, asPath, pathname } = router;
  const { width } = useWindowSize();
  useEffect(() => {
    if (width <= 768 && !query?.redirect && asPath !== pathname) {
      router.push(`/mobile?redirectPath=${asPath}`);
    }
  }, [width, query, asPath, pathname]);
}
